<!-- カレンダーコンポーネント -->
<template>
  <div class="calendar">
    <!-- ヘッダ -->
    <header class="header">
      <div class="header-year-month">
        {{ titleCal }}
      </div>
      <!--ボタン-->
      <div class="button-wrapper">
        <div class="button button-left" @click="previousMonth">
          <i class="fas fa-caret-left"></i>
        </div>
        <div class="button button-middle" @click="jumpToToday">今日</div>
        <div class="button button-right" @click="nextMonth">
          <i class="fas fa-caret-right"></i>
        </div>
      </div>
    </header>
    <!--日月火水木金土〜-->
    <div class="headings">
      <div
        v-for="(dayLabel, index) in dayLabels"
        :key="index"
        class="dayOfWeekLabel"
      >
        {{ dayLabel }}
      </div>
    </div>
    <!--日付-->
    <div class="days">
      <div
        v-for="(day, index) in daysArray"
        :key="index"
        class="day"
        :class="{
          enableChangeSize: EnableChangeCallenderSize,
          disableChangeSize: !EnableChangeCallenderSize
        }"
      >
        <div
          @click="setSelectedDate(day)"
          :class="{
            isCurrentMonth: !day.isCurrentMonth,
            isSelected: day.isSelected,
            isToday: day.isToday
          }"
          :data-test="day.date | formattedDate"
        >
          <span class="dayLabel">{{ day.date | formattedDate }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import format from "date-fns/format";
import dateFns from "date-fns";
import jsLocale from "date-fns/locale/ja";
const dateObj = new Date();
export default {
  data() {
    return {
      today: null,
      selectedDate: null,
      currDateCursor: null,
      dayLabels: null
    };
  },
  created() {
    const DAY_LABELS = [
      this.$i18n.t("calendar.sun"),
      this.$i18n.t("calendar.mon"),
      this.$i18n.t("calendar.tue"),
      this.$i18n.t("calendar.wed"),
      this.$i18n.t("calendar.thu"),
      this.$i18n.t("calendar.fri"),
      this.$i18n.t("calendar.sat")
    ];
    this.dayLabels = DAY_LABELS.slice();
    this.today = new Date();
    this.selectedDate = this.today;
    this.currDateCursor = this.today;
    this.$emit("set", this.today);
  },
  computed: {
    currentMonth() {
      return this.currDateCursor.getMonth();
    },
    currentYear() {
      return this.currDateCursor.getFullYear();
    },
    currentMonthLabel() {
      const MONTH_LABELS = [
        this.$i18n.t("calendar.jan"),
        this.$i18n.t("calendar.feb"),
        this.$i18n.t("calendar.mar"),
        this.$i18n.t("calendar.apr"),
        this.$i18n.t("calendar.may"),
        this.$i18n.t("calendar.jun"),
        this.$i18n.t("calendar.jul"),
        this.$i18n.t("calendar.aug"),
        this.$i18n.t("calendar.sep"),
        this.$i18n.t("calendar.oct"),
        this.$i18n.t("calendar.nov"),
        this.$i18n.t("calendar.dec")
      ];
      return MONTH_LABELS[this.currentMonth];
    },
    day() {
      return format(dateObj, "YYYY/MM/DD", { locale: jsLocale });
    },
    titleCal() {
      return format(this.currDateCursor, "YYYY年MM月", { locale: jsLocale });
    },
    daysArray() {
      const date = this.currDateCursor;
      const startOfMonth = dateFns.startOfMonth(date);
      const endOfMonth = dateFns.endOfMonth(date);
      const days = dateFns.eachDay(startOfMonth, endOfMonth).map(day => ({
        date: day,
        isCurrentMonth: dateFns.isSameMonth(
          new Date(this.currentYear, this.currentMonth),
          day
        ),
        isToday: dateFns.isToday(day),
        isSelected: dateFns.isSameDay(this.selectedDate, day)
      }));
      let previousMonthCursor = dateFns.lastDayOfMonth(
        dateFns.addMonths(date, -1)
      );
      const begIndex = dateFns.getDay(days[0].date);
      for (let i = begIndex; i > 0; i--) {
        days.unshift({
          date: previousMonthCursor,
          isCurrentMonth: false,
          isToday: dateFns.isToday(previousMonthCursor),
          isSelected: dateFns.isSameDay(this.selectedDate, previousMonthCursor)
        });
        previousMonthCursor = dateFns.addDays(previousMonthCursor, -1);
      }
      // gen days for next month
      const daysNeededAtEnd = days.length % 7 > 0 ? 7 - (days.length % 7) : 0;
      let nextMonthCursor = dateFns.addMonths(date, 1);
      nextMonthCursor = dateFns.setDate(nextMonthCursor, 1);
      for (let x = 1; x <= daysNeededAtEnd; x++) {
        days.push({
          date: nextMonthCursor,
          isCurrentMonth: false,
          isToday: dateFns.isToday(nextMonthCursor),
          isSelected: dateFns.isSameDay(this.selectedDate, nextMonthCursor)
        });
        nextMonthCursor = dateFns.addDays(nextMonthCursor, 1);
      }
      return days;
    },
    EnableChangeCallenderSize() {
      // カレンダーに表示する表示行数を計算
      const rowsOfCallender = this.daysArray.length / 7;

      // 表示行数より、サイズ変更するかどうかを決定
      if (rowsOfCallender > 5) {
        return true;
      } else return false;
    }
  },
  filters: {
    formattedDate(val) {
      return dateFns.format(val, "D");
    }
  },
  methods: {
    setSelectedDate(day) {
      this.selectedDate = day.date;
      this.$emit("set", this.selectedDate);
    },
    nextMonth() {
      this.currDateCursor = dateFns.addMonths(this.currDateCursor, 1);
    },
    previousMonth() {
      this.currDateCursor = dateFns.addMonths(this.currDateCursor, -1);
    },
    jumpToToday() {
      this.selectedDate = this.today;
      this.currDateCursor = this.today;
      this.$emit("set", this.today);
    }
  }
};
</script>

<style scoped>
.calendar {
  width: 100%;
  height: 100%;
  padding: 10px;
  background-color: #c5d7ef;
  border-radius: 10px;
}
.headers,
.headings {
  margin-top: 10px;
}
.header {
  /* 
  display: grid;
  grid-template-columns: 1fr 1fr 1fr ;
  display: flex;
  */
  overflow: hidden;
}
/* 
.header > .button-wrapper {
  justify-self: end;
}
*/
.header-year-month {
  /* 
    display: flex;
    transform: translateY(10%);
  */
  font-weight: bold;
  font-size: 1.3rem;
  margin-top: 10px;
}
/* 
.header-year-month > div {
  margin-left: 20px;
}
*/
.button-wrapper {
  display: flex;
  float: right;
}
.button {
  border: 2px solid #ffffff;
  background-color: #cecdce;
  height: 40px;
  line-height: 40px;
}
.button:hover {
  cursor: pointer;
}
.button-left {
  margin-right: 1px;
  border-radius: 5px 0 0 5px;
  padding: 0 5px 0 5px;
}
.button-middle {
  width: 70px;
  font-size: 20px;
  font-weight: 900;
}
.button-right {
  margin-left: 1px;
  border-radius: 0 5px 5px 0;
  padding: 0 5px 0 5px;
}
.button-left,
.button-right {
  width: 25px;
  font-size: 30px;
}
.dayOfWeekLabel {
  font-weight: bold;
  padding-top: 10px;
  height: 30px;
}
.headings {
  clear: both;
}
.headings,
.days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  height: fit-content;
}
.day {
  border: 1px solid #d5d4d5;
  background-color: #ffffff;
}
.dayLabel {
  position: relative;
  left: 10px;
  font-weight: bold;
  font-size: 1rem;
}
.enableChangeSize {
  line-height: 50px;
  height: 51px;
}
.disableChangeSize {
  line-height: 60px;
  height: 61px;
}
.day:hover {
  cursor: pointer;
}
.isCurrentMonth {
  color: #a6abaf;
}
.isSelected {
  background-color: #efefef;
}
.isToday {
  color: #409ce0;
}
</style>
